import getIntersectionArea, { Offset } from 'utils/get-intersection-area';

export default (element: HTMLElement, offset: Offset = { x: 0, y: 0 }) => {
  const rect = element.getBoundingClientRect();
  const totalArea = rect.width * rect.height;

  return (getIntersectionArea(element, offset) / totalArea) * 100;
};
